(function () {

    function safeClosest(target, selector) {
        let el = target;

        // If it's a Text node or something weird
        if (el && el.nodeType && el.nodeType !== 1) el = el.parentElement;

        while (el && el !== document) {
            if (el.matches && el.matches(selector)) return el;
            el = el.parentElement;
        }
        return null;
    }

    function lockScroll() {
        document.documentElement.classList.add('share-modal-open', 'overflow-hidden');
        document.body.classList.add('share-modal-open', 'overflow-hidden');
    }

    function unlockScroll() {
        document.documentElement.classList.remove('share-modal-open', 'overflow-hidden');
        document.body.classList.remove('share-modal-open', 'overflow-hidden');
    }

    function openModal(modal) {
        modal.removeAttribute('hidden');
        lockScroll();
    }

    function closeModal(modal) {
        modal.setAttribute('hidden', '');
        unlockScroll();
    }

    // IMPORTANT: capture = true (3rd arg) so we still get clicks even if other scripts stopPropagation
    document.addEventListener(
        'click',
        async (e) => {
            const modal = document.getElementById('spraga-share-modal');
            if (!modal) return;

            const copyBtn  = safeClosest(e.target, '[data-share-copy]');
            const openBtn  = safeClosest(e.target, '[data-share-open]');
            const closeBtn = safeClosest(e.target, '[data-share-close]');

            // Copy first
            if (copyBtn) {
                e.preventDefault();

                const val = copyBtn.getAttribute('data-share-copy') || '';
                try {
                    await navigator.clipboard.writeText(val);

                    const badge = modal.querySelector('.spraga-share-copied');
                    if (badge) {
                        badge.hidden = false;
                        window.clearTimeout(badge._t);
                        badge._t = window.setTimeout(() => {
                            badge.hidden = true;
                        }, 1500);
                    }
                } catch (_) {}
                return;
            }

            // Open
            if (openBtn) {
                e.preventDefault();
                if (modal.hasAttribute('hidden')) openModal(modal);
                return;
            }

            // Close
            if (closeBtn) {
                e.preventDefault();
                if (!modal.hasAttribute('hidden')) closeModal(modal);
                return;
            }
        },
        true
    );

    document.addEventListener('keydown', (e) => {
        if (e.key !== 'Escape') return;

        const modal = document.getElementById('spraga-share-modal');
        if (modal && !modal.hasAttribute('hidden')) {
            modal.setAttribute('hidden', '');
            unlockScroll();
        }
    });

    document.addEventListener('click', async (e) => {
        const btn = e.target.closest('.spraga-share-copy-btn');
        if (!btn) return;

        const val = btn.getAttribute('data-share-copy');
        if (!val) return;

        e.preventDefault();

        if (!navigator.clipboard || !navigator.clipboard.writeText) {
            console.warn('Clipboard API not supported');
            return;
        }

        try {
            await navigator.clipboard.writeText(val);

            const block = btn.closest('.spraga-share-copy');
            const badge = block?.querySelector('.spraga-share-copied');
            if (!badge) return;

            badge.hidden = false;
            clearTimeout(badge._timeout);
            badge._timeout = setTimeout(() => {
                badge.hidden = true;
            }, 3000);
        } catch (err) {
            console.warn('Copy failed', err);
        }
    });
})();
